import React from 'react';
import { BrandsList } from '../components/brands_list/brands_list';
import { ContentWrapper } from '../components/content_wrapper/content_wrapper';
import { ScrollToTop } from '../components/scroll_to_top/scroll_to_top';
import { SEO } from '../components/seo/seo';

const BrandsPage = () => {
  return (
    <ScrollToTop>
      <SEO
        title="Our Brands"
        description="Information about all brands of fishing gear that Omnia Fishing carries - check out brand pages to browse tackle, technology, gear, and more."
      />
      <ContentWrapper tag="section">
        <BrandsList />
      </ContentWrapper>
    </ScrollToTop>
  );
};

export default BrandsPage;
